// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 3524 ? "app" : chunkId) + "." + {"1867":"10ce2bdb4c854c95a31d","3524":"bcf3ce7b65005d5a1d8f"}[chunkId] + ".css";
};